var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "7 6 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 6h16v4H7zM8 11v11h14V11Zm11 4h-8v-2h8Z"
})));
export default SvgArchive;